(() => {
  const FEE_VARIANT_ID = 52717216956759;

  let checkoutInProgress = false;

  function cartUrl(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/?$/, '/')}${path.replace(/^\//, '')}`;
  }

  async function getCart() {
    const response = await fetch(cartUrl('cart.js'), {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error(`Unable to read cart: ${response.status}`);
    }

    return response.json();
  }

  async function changeLineItem(key, quantity) {
    const response = await fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error(`Unable to correct fee quantity: ${response.status}`);
    }

    return response.json();
  }

  async function sanitiseFee() {
    let cart = await getCart();

    let feeItems = cart.items.filter(
      item => Number(item.variant_id) === FEE_VARIANT_ID
    );

    if (!feeItems.length) {
      return cart;
    }

    /*
     * There should be ONE fee line with quantity ONE.
     *
     * Normally Magical Fees creates a single line, but this also
     * protects against the fee somehow appearing as multiple lines.
     */
    for (let i = 0; i < feeItems.length; i++) {
      const item = feeItems[i];
      const requiredQuantity = i === 0 ? 1 : 0;

      if (item.quantity !== requiredQuantity) {
        await changeLineItem(item.key, requiredQuantity);
      }
    }

    /*
     * Fetch again so we validate the server-side cart,
     * rather than trusting the cart drawer DOM.
     */
    cart = await getCart();

    feeItems = cart.items.filter(
      item => Number(item.variant_id) === FEE_VARIANT_ID
    );

    const totalFeeQuantity = feeItems.reduce(
      (total, item) => total + item.quantity,
      0
    );

    if (totalFeeQuantity > 1 || feeItems.length > 1) {
      throw new Error(
        `Fee validation failed. Lines: ${feeItems.length}, quantity: ${totalFeeQuantity}`
      );
    }

    return cart;
  }

  async function safeCheckout(button) {
    if (checkoutInProgress) return;

    checkoutInProgress = true;

    const originalDisabled = button.disabled;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      await sanitiseFee();

      /*
       * Do NOT submit CartDrawer-Form here.
       *
       * We have already validated Shopify's real cart state.
       * Go directly to checkout.
       */
      window.location.assign(cartUrl('checkout'));
    } catch (error) {
      console.error('[Fee Checkout Guard]', error);

      /*
       * Fail safely.
       *
       * If we cannot guarantee the fee is correct, send the customer
       * to the full cart page instead of allowing an incorrect checkout.
       * A full page load also causes Magical Fees to recalculate.
       */
      window.location.assign(cartUrl('cart'));
    } finally {
      checkoutInProgress = false;
      button.disabled = originalDisabled;
      button.removeAttribute('aria-busy');
    }
  }

  /*
   * Capture phase is deliberate: we want to catch the checkout action
   * before the theme's normal CartDrawer-Form submission.
   */
  document.addEventListener(
    'click',
    event => {
      const button = event.target.closest('#CartDrawer-Checkout');

      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      safeCheckout(button);
    },
    true
  );
})();